module.exports = __webpack_public_path__ + "img/estoque.143f4847.svg";